import { render, staticRenderFns } from "./ActionJournal.vue?vue&type=template&id=18ffa720"
import script from "./ActionJournal.vue?vue&type=script&lang=js"
export * from "./ActionJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports